<template>
  <div class="modal fade" id="editBankModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('editBank.title') }}</h5>
          <button type="button" class="close" data-dismiss="modal" :aria-label="$t('common.close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="banks.length === 0">
            {{ $t('editBank.loadingBanks') }}
          </div>
          <div v-else>
            <div class="form-group">
              <label for="bankSelect">{{ $t('editBank.selectBankLabel') }}</label>
              <select v-model="selectedBank" id="bankSelect" class="form-control">
                <option v-for="bank in banks" :value="bank.bank_id" :key="bank.bank_id">{{ bank.bank_name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('common.cancel') }}</button>
          <button type="button" class="btn btn-primary" @click="save">{{ $t('common.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['editBank', 'banks', 'currentBank'],
  data() {
    return {
      selectedBank: this.currentBank
    }
  },
  watch: {
    currentBank(newVal) {
      this.selectedBank = newVal
    }
  },
  methods: {
    save() {
      this.editBank(this.selectedBank)
      $('#editBankModal').modal('hide')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/editBank.vue